
up.compiler('.select_expertise_animation', function(element, data) {
  const existings = JSON.parse(element.dataset.defaultid)
  const selector = new Choices(element, {
    placeholder: true,
    placeholderValue: 'Expertises',
    removeItemButton: true,
    choices: data.map((e) => {
      let res = {value: e.id, label: e.fr_name}
      if (existings.find((existing) => e.id == existing.id)) {res['selected'] = true}
      return res
    }),
  });

  return () => {
    selector.destroy()
  }
})